import {Component, EventEmitter, Input, Output} from '@angular/core';
import {icon, Map, Marker} from 'leaflet';
import {MarkerBase} from "./service/marker-base";
import {LeafletModule} from "@bluehalo/ngx-leaflet";

const iconRetinaUrl = 'assets/markers/marker-icon-2x.png';
const iconUrl = 'assets/markers/marker-icon.png';
const shadowUrl = 'assets/markers/marker-shadow.png';
const iconDefault = icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  imports: [
    LeafletModule
  ],
  styleUrls: ['./map.component.scss']
})
export class MapComponent {


  @Output() map$: EventEmitter<Map> = new EventEmitter;
  @Output() zoom$: EventEmitter<number> = new EventEmitter;


  //layers: Marker<any>[] | Circle<any>[] | Polygon<any>[] = [];
  //polygon([[46.8, -121.85], [46.92, -121.92], [46.87, -121.8]]),
  //marker([46.879966, -121.726909])
  //layer = marker([46.95, -122]);

  //public map!: Map;
  //public zoom!: number;

  @Input("markerService") markerBaseService: MarkerBase = new MarkerBase();


  constructor() {
  }

  ngOnInit() {
    this.markerBaseService.print()
    this.subscribeToMarkerService();
  }

  subscribeToMarkerService() {

  }


  ngOnDestroy() {
    //this.map.clearAllEventListeners();
    //this.map.remove();
  };

  onMapReady(map: Map) {
    // add all devices to layers


    /*this.map = map;
    this.map$.emit(map);
    this.zoom = map.getZoom();
    this.zoom$.emit(this.zoom);*/
  }

  // onMapZoomEnd(e: ZoomAnimEvent) {
  //   this.zoom = e.target.getZoom();
  //   this.zoom$.emit(this.zoom);
  // }
}
